module.exports = __webpack_public_path__ + "assets/chevron-up-down.9a10ce2a.svg";